import { AutoAcceptPaymentsStatus } from "@/api-v3";

export const shouldOfferAutoAccept = (
  status: AutoAcceptPaymentsStatus | undefined,
  hasPayoutAccount: boolean
) => hasPayoutAccount && status === AutoAcceptPaymentsStatus.not_asked;
